import SET_ACTIVE_COURSE_RUN from '@data/constants/actionTypes/activeCourseRun';

const setActiveCourseRun = value => ({
  type: SET_ACTIVE_COURSE_RUN,
  value,
});

export default setActiveCourseRun;
